import * as axios from 'axios';

function get_token( card_number, card_expire, cardholder_name, security_code, onSuccess, onError, locale ) {
    const params = {
        'card_number': card_number,
        'card_expire': card_expire,
        'security_code': security_code,
        'cardholder_name': cardholder_name,
        'token_api_key': import.meta.env.VITE_MDK_API_KEY,
        'lang': locale
    }
    axios.post('https://api3.veritrans.co.jp/4gtoken', params).then((res) => {
        onSuccess(res.data.token)
    }).catch((err) => {
        console.log(err)
        onError(err.response.data.message)
    })
}
export { get_token };
